var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttach(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9191 1.96309L4.02839 11.8041C3.02787 13.233 3.20102 15.263 4.57565 16.3369C5.97624 17.4343 8.00124 17.1885 9.09861 15.7879C9.1342 15.7425 9.1685 15.6962 9.20162 15.6489L14.9351 7.4606C15.1392 7.16914 15.0684 6.7674 14.7769 6.56327C14.4854 6.35919 14.0837 6.43002 13.8796 6.7215L8.20932 14.8195C7.62937 15.6477 6.50501 15.9851 5.62312 15.4906C4.69013 14.9714 4.35463 13.7942 4.87382 12.8612C4.90611 12.8032 4.94136 12.7469 4.97945 12.6925L11.9747 2.70219C12.9952 1.24479 15.0039 0.890597 16.4613 1.91107C17.9187 2.93155 18.2729 4.94029 17.2525 6.39772L10.2415 16.4104C8.8904 18.34 6.2732 19.0752 4.22411 17.9134C2.05317 16.6913 1.28387 13.9406 2.506 11.7696C2.57837 11.6411 2.65693 11.5162 2.74153 11.3954L8.60184 3.02592C8.80593 2.73445 8.7351 2.33271 8.44362 2.12859C8.15214 1.92446 7.75042 1.99533 7.54629 2.28681L1.68597 10.6562C-0.150899 13.2795 0.486603 16.8952 3.10992 18.732L3.10997 18.7321L3.10997 18.7321C6.27663 20.9494 9.8083 19.2756 11.2865 17.1645L18.308 7.13675C19.7367 5.09637 19.2408 2.28413 17.2004 0.855476C15.16 -0.57313 12.3478 -0.0772616 10.9191 1.96309Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.df41b78b81d4afd7a5353a7ec19f6d44.svg";
export { ForwardRef as ReactComponent };